import React from 'react';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { FormGroup } from 'arag-ui-lib';
import QuestionEditActions from "../QuestionEditActions";

const TextAreaInputType = (props) => {
    const {
        question,
        value,
        formData,
        isPlain,
        application,
        hasInlineElements,
        textHandler,
        textAreaRows = 3,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        openHistoryModal,
        isLabelClickable,
    } = props;
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.TEXT_AREA;
    return (
        <FormGroup
            variant={variant}
            labelSize={"col-sm-3"}
            inputSize={"col-sm-6"}
            label={question.name}
            inputProps={{
                id: `question-id-${question.id}`,
                name: question.machineName,
                label: isPlain ? value : '',
                value: isPlain ? '' : value,
                onChange: (evt) => textHandler(question.id, evt.target.value),
                rows: textAreaRows,
                required: question.isRequired,
            }}
            hasInlineElements={hasInlineElements}
            inlineGroupElements={
                hasInlineElements 
                ?
                    <div className={"col-sm-3"}>
                        <QuestionEditActions
                            checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                            question={question}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            approvalOptions={approvalOptions}
                            onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                            hasPendingChanges={checkIfQuestionHasPendingChanges( question.id, application )}
                        />
                    </div>
                :
                    null
            }
            onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined }
            formGroupTestId={`policy-application-${question.machineName}`}
        />
    );
};

export default TextAreaInputType;